import enquire from 'enquire.js/dist/enquire.min';
/**
 * featured-quotes
 */
// run js depends on the screen size
enquire.register('screen and (max-width: 767px)', {
    match: function () {
        $('.s-featured-quotes__carousel-item-inner').removeClass('text-color-light');
        $('.s-featured-quotes__row').removeClass('section--bg-img');
    },
    unmatch: function () {
        $('.s-featured-quotes__carousel-item-inner').addClass('text-color-light');
        $('.s-featured-quotes__row').addClass('section--bg-img');
    },
});



// WEBPACK FOOTER //
// ./scripts/routes/sections/featured-quotes.js